import {Exclude, Expose, instanceToPlain, plainToInstance, Transform} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {Entity} from "./entity";
import {getDatabaseCodeTransformer} from "./transfomers/transformers";
import {PersonCapabilityType, toPersonCapabilityType} from "./person-capability-type";

export const PersonCapabilityCodec = t.intersection([
  t.type({
    id: t.string,
    personId: t.string,
    capability: t.string,
    primary: t.boolean,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
  t.partial({
    createdById: t.string,
    lastModifiedById: t.string,
  }),
]);

export type PersonCapability = t.TypeOf<typeof PersonCapabilityCodec>;

@Exclude()
export class PersonCapabilityEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  personId!: string;

  @Transform(getDatabaseCodeTransformer(toPersonCapabilityType))
  @Expose()
  capability!: PersonCapabilityType;

  @Expose()
  primary!: boolean;

  @Expose()
  createdById?: string;

  @Expose()
  lastModifiedById?: string;

  @Expose()
  createDttm!: number;

  @Expose()
  lastModifiedDttm!: number;

  readonly entityType = 'PERSONCAP';

  get displayName(): Readonly<string> {
    return this.id;
  }

  /**
   * Constructor for PersonCapabilityEntity. Recommend using the {@link create} method instead.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(value: PersonCapability): PersonCapabilityEntity {
    return plainToInstance(PersonCapabilityEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<PersonCapability> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(PersonCapabilityCodec, object);
  }

  asTypeValue(): PersonCapability {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(PersonCapabilityCodec, object);
  }
}

export interface PersonCapabilityRequestDTO {
  capabilities: string[]
}

export interface PersonCapabilityPatchRequestDTO {
  add: string[]
  remove: string[]
}
